import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { EnvelopeType } from '../../../global-types/envelope';
import { EnvelopeRadioGroupProps } from '../address-form-types';
import styles from '../address-form.module.scss';
import { CUIText, RadioButton } from '@dotcom/crown-ui';

/**
 * This component handles the envelope part of the address form.
 * Contains a selection of the envelope based on radio buttons
 */
export const EnvelopeRadioGroup = React.memo(({ register, envelope }: EnvelopeRadioGroupProps) => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const [searchParams] = useSearchParams(search);
  const navigate = useNavigate();

  useEffect(() => {
    searchParams.set('envelope', envelope);
    navigate({ pathname: '/card/customization/address', search: searchParams.toString() });
  }, [envelope, navigate, searchParams]);

  const envelopeRegister = register('envelope', { required: true });

  return (
    <div className={styles.addressing}>
      <CUIText as="span" color="textPrimary" data-testid="description">
        {t('addressing.description')}
      </CUIText>
      <div role="radiogroup" aria-labelledby="radio_button_group">
        <RadioButton
          domId={'blank-envelope-card'}
          testId={'blank-envelope-card'}
          value={EnvelopeType.Blank}
          className={styles['radio-card']}
          register={envelopeRegister}
        >
          {t('addressing.blankEnvelope')}
        </RadioButton>
        <RadioButton
          domId={'return-envelope-card'}
          testId={'return-envelope-card'}
          value={EnvelopeType.Return}
          className={styles['radio-card']}
          register={envelopeRegister}
        >
          {t('addressing.returnEnvelope')}
        </RadioButton>
      </div>
    </div>
  );
});
